import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { LocationContextService } from '../../../../client/app/location-context/location-context.service';
import { DockingService } from '../docking.service';

@Injectable()
export class DockingResolver implements Resolve<void> {
    constructor(
        private readonly dockingService: DockingService,
        private readonly locationContextService: LocationContextService
    ) {}

    resolve() {
        this.dockingService.requestDockingContext(this.locationContextService.getLocationContext());
    }
}
